import { render, staticRenderFns } from "./ShareCustomersDepartment.vue?vue&type=template&id=46c8518e"
import script from "./ShareCustomersDepartment.vue?vue&type=script&lang=js"
export * from "./ShareCustomersDepartment.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomersDepartment.vue?vue&type=style&index=0&id=46c8518e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports